export const FEATURE_FLAGS = {
  AGENT_BOTS: 'agent_bots',
  AGENT_MANAGEMENT: 'agent_management',
  AUTO_RESOLVE_CONVERSATIONS: 'auto_resolve_conversations',
  AUTOMATIONS: 'automations',
  CAMPAIGNS: 'campaigns',
  CANNED_RESPONSES: 'canned_responses',
  CRM: 'crm',
  CUSTOM_ATTRIBUTES: 'custom_attributes',
  INBOX_MANAGEMENT: 'inbox_management',
  INTEGRATIONS: 'integrations',
  LABELS: 'labels',
  MACROS: 'macros',
  HELP_CENTER: 'help_center',
  REPORTS: 'reports',
  TEAM_MANAGEMENT: 'team_management',
  VOICE_RECORDER: 'voice_recorder',
  AUDIT_LOGS: 'audit_logs',
  WHATSAPP_TEMPLATES: 'whatsapp_templates',
  DOMESTIC_CALLS: 'domestic_calls',
  PAYMENT_DASHBOARD: 'payment_dashboard',
  SCHEDULE_DEMO:'schedule_demo',
  AUTO_ASSIGNE_BOTH:'auto_assigne_agent_both',
  REMINDER_ALL_DATA: 'show_reminder_statuses',
  FILTER_BOARD:'filter_board',
  Account_TimeStamp :'account_timestamp_format',
  FILTER_BOARD:'filter_board',
  Account_TimeStamp :'account_timestamp_format',
  ACTIONS_FILTERS:'actions_filters',
  MAAC_CLIENT_BRANCH:'maac_client_branch',
  SMART_AI_EMAIL_CAMPAIGN: 'smart_ai_email_campaign',
  CONTACT_SUMMARY: 'contact_summary',
  LEAD_QUALITY: 'lead_quality',
  /** Account feature from config/features.yml — toggled per account in Super Admin */
  ENABLE_LEAD_RESPONSE_WATCH: 'enable_lead_response_watch',
  META_CONVERSION_BOARD_SYNC: 'meta_conversion_board_sync',
  AGENT_COMMUNICATION_SCORE_EMAIL: 'agent_communication_score_email',
};
 